export const hideDeliveryInputsOnSelect = {
  /**
   * @type {OrderFormBySteps}
   */
  parent: null,

  baseInputs: [
    '#step4 .ckeckout-map-block',
    '#index',
    '#region',
    '#flatRoom',
    '#floor',
    '#flat',
    '#intercom_code',
    '#date',
  ],

  init() {
    this.hide();
  },

  hide() {
    const inputs = this.parent.order.querySelectorAll('input[name="delivery_method"]');
    const checkedInput = this.parent.order.querySelector('input[name="delivery_method"]:checked');
    const inputsCol = this.parent.order.querySelector('#step-4 form .form-row')?.children;

    [...inputs].forEach((input) => {
      this.switchMode(inputsCol, checkedInput.value);
      input.addEventListener('click', (e) => {
        this.switchMode(inputsCol, e.currentTarget.value);
      });
    });
  },

  switchMode(inputsCol, val) {
    this.unHide(inputsCol);
    document.querySelector('.cdek-message')?.classList.remove('d-none');
    switch (val) {
      case '1':
        this.hideSelectedInputs(this.baseInputs);
        this.clearAllFields();
        break;
      case '2':
        document.querySelector('.cdek-message')?.classList.add('d-none');
        this.hideSelectedInputs(['#index', '#region']);
        break;
      case '3':
        document.querySelector('.cdek-message')?.classList.add('d-none');
        this.hideSelectedInputs(['#floor', '#flatRoom', '#intercom_code', '#date']);
        break;
      case '4':
        document.querySelector('.mail-message')?.classList.add('d-none');
        this.hideSelectedInputs(['#index', '#region', '#floor', '#flatRoom', '#intercom_code', '#date']);
        break;
      default:
        this.hideSelectedInputs(this.baseInputs);
    }
  },

  unHide(inputsCol) {
    [...inputsCol].forEach((inputCol) => {
      inputCol.classList.remove('d-none');
      inputCol.querySelector('input, select, textarea, checkbox').disabled = false;
    });
  },

  /**
   * @param {[string]} arr
   */
  hideSelectedInputs(arr) {
    [...arr].forEach((inputName) => {
      if (document.querySelector(inputName) !== null) {
        const inputCol = document.querySelector(inputName).closest('.col-sm-6');
        if (inputCol !== null) {
          inputCol.classList.add('d-none');
          inputCol.querySelector('input, select, textarea, checkbox').disabled = true;
          inputCol.querySelector('input, select, textarea').value = '';
        }
      }
    });
  },

  clearAllFields() {
    const form = this.parent.order.querySelector('#step-4 form');
    form.reset();
  },

  setParent(parentClass) {
    this.parent = parentClass;
    return this;
  },
};
